import Bowser from "bowser";
export class EvalError {
    constructor(original, context, is_python) {
        const action = original instanceof SyntaxError ? "parsing" : "running";
        let trace;
        if (action === "running" && original.stack) {
            try {
                if (is_python) {
                    trace = parsePythonStack(original.message);
                }
                else {
                    trace = parseStack(original.stack, original);
                }
            }
            catch (e) {
                console.error("Could not parse error stack correctly: " + original.stack);
                console.error(e);
            }
        }
        if (!trace) {
            const origMessage = extractOriginalMessage(original);
            this.message = `${action} ${context}: ${origMessage}`;
        }
        else if (trace.line && trace.column) {
            this.line = trace.line;
            this.column = trace.column;
            this.message = `${action} ${context} at ${trace.line}:${trace.column}: ${trace.message}`;
        }
        else if (trace.line) {
            this.line = trace.line;
            this.message = `${action} ${context} at ${trace.line}: ${trace.message}`;
        }
        else {
            this.message = `${action} ${context}: ${trace.message}`;
        }
        this.context = context;
        this.action = action;
    }
}
function extractOriginalMessage(original) {
    if (typeof original === "string") {
        return original;
    }
    if (original instanceof Error) {
        return original.toString();
    }
    return original.message;
}
function parseStack(stack, original) {
    let searchStr = "<anonymous>";
    if (typeof navigator !== "undefined") {
        const browser = Bowser.getParser(navigator.userAgent);
        searchStr = browser.is("chrome") ? "<anonymous>" : "> Function";
    }
    let data = stack.split("\n").find((line) => line.includes(searchStr));
    data = data.slice(data.lastIndexOf(searchStr));
    const [line, column] = data
        .split(":")
        .slice(1)
        .map((v) => parseInt(v));
    const message = extractOriginalMessage(original);
    return {
        line: line - 2,
        column: column,
        message: message,
    };
}
const fixPyFrame = (pyLine) => {
    const lineNumPrefix = "line ";
    const iPrefix = pyLine.indexOf(lineNumPrefix);
    if (iPrefix < 0) {
        throw new Error("Couldn't find line number in Python trace");
    }
    const iLineNum = iPrefix + lineNumPrefix.length;
    let lineNumEnd = pyLine.indexOf(",", iLineNum);
    if (lineNumEnd < 0)
        lineNumEnd = pyLine.length;
    const lineNum = parseInt(pyLine.slice(iLineNum, lineNumEnd));
    const fixed = pyLine.slice(0, iLineNum) + lineNum + pyLine.slice(lineNumEnd);
    return { lineNum: lineNum, fixed: fixed };
};
const lastIndexOfPythonStack = (lines) => {
    let pyLast = lines.length - 1;
    if (pyLast < 0) {
        throw new Error("Python trace is empty");
    }
    while (true) {
        if (!lines[pyLast].trimLeft().startsWith("at"))
            break;
        if (pyLast === 0) {
            throw new Error("Couldn't find Python trace");
        }
        pyLast -= 1;
    }
    return pyLast;
};
function parsePythonStack(stack) {
    const lines = stack.split("\n");
    const pyLast = lastIndexOfPythonStack(lines);
    const pyLines = lines.slice(0, pyLast + 1);
    let behaviorLineNum;
    for (var i = 0; i < pyLines.length; ++i) {
        try {
            const frame = fixPyFrame(pyLines[i]);
            pyLines[i] = frame.fixed;
            if (pyLines[i].trimRight().endsWith(" behavior")) {
                behaviorLineNum = frame.lineNum;
            }
        }
        catch (e) {
        }
    }
    const message = pyLines.join("\n");
    return {
        line: behaviorLineNum,
        column: undefined,
        message: message,
    };
}
//# sourceMappingURL=EvalError.js.map